import type { TAddressBookItem, TAddressesResponse } from "../models/addresses";
import type { TAddressBookEntry, TLockerType } from "../types";

const mapLockerResponse = (locker: TAddressBookItem["locker"]): TLockerType | null =>
  locker
    ? {
        id: locker.id,
        name: locker.name,
        address: {
          country: locker.address.country,
          postalCode: locker.address.postalCode,
        },
      }
    : null;

const mapAddressBookResponse = (response: TAddressesResponse): TAddressBookEntry[] =>
  (response.items || []).map((item) => ({
    id: item.id,
    contactName: item.contactName,
    contactEmail: item.contactEmail,
    contactPhone: item.contactPhone,
    locker: mapLockerResponse(item.locker),
    lockerId: item.lockerId,
    country: item.country,
    countryCode: item.countryCode,
    city: item.city,
    street: item.street,
    streetNumber: item.streetNumber,
    flatNo: item.flatNo,
    zip: item.zip,
  }));

export default mapAddressBookResponse;
